module.exports = __webpack_public_path__ + "img/AMWETCarousel_feet.cb5f8880.webp";